module.exports = __webpack_public_path__ + "static/img/weather.618cdf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2dmap/weather.png
// module id = cO2O
// module chunks = 2